import { PageId } from 'constants/pages'

export const enum PageIdWoofzOffer175 {
  SUBSCRIPTIONS_OFFER1_75 = PageId.SUBSCRIPTIONS_OFFER1_75,
  CHAT_UPSELL_OFFER1_75 = PageId.CHAT_UPSELL_OFFER1_75,
  UPSELL_OFFER1_75 = PageId.UPSELL_OFFER1_75,
  DOWNLOAD_OFFER1_75 = PageId.DOWNLOAD_OFFER1_75,
  ACCOUNT_NOVE8 = PageId.ACCOUNT_NOVE8,
}
